export const enum LoginMode {
  SSO = 'SSO',
  MicrosoftSSO = 'MICROSOFT_SSO',
}

export enum TwoFactorVerificationType {
  TOTP = 'totp',
  BACKUP = 'backup',
}

export enum ChangePasswordReason {
  TemporaryPassword = 'temporary_password',
  PasswordExpired = 'password_expired',
}
